import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grow px-6 py-5" }
const _hoisted_2 = { class: "text-xl font-medium text-secondary" }
const _hoisted_3 = { class: "text-sm text-gray-400" }
const _hoisted_4 = {
  key: 0,
  class: "flex bg-primary items-center justify-center -right-2 -top-2 text-[10px] text-white h-5 w-5 rounded-full ring-2 ring-white"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 px-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "9",
    height: "40",
    viewBox: "0 0 9 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.02899 20.4773L2.56306 25.9432C2.29944 26.2068 1.87206 26.2068 1.60847 25.9432L0.97096 25.3057C0.707794 25.0425 0.707288 24.616 0.969835 24.3522L5.30168 20L0.969835 15.6478C0.707288 15.384 0.707794 14.9575 0.97096 14.6943L1.60847 14.0568C1.87208 13.7932 2.29947 13.7932 2.56306 14.0568L8.02896 19.5227C8.29257 19.7863 8.29257 20.2137 8.02899 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createVNode(_component_router_link, {
      to: _ctx.getRoute(),
      class: "flex items-center bg-white text-sm text-gray-400"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.subTitle), 1)
        ]),
        (_ctx.messages && _ctx.messages > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.messages) + "+ ", 1))
          : _createCommentVNode("", true),
        _hoisted_5
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}